import type { ReactElement } from 'react'

interface ModalBackdropProps {
  ariaLabel: string
  onClose: () => void
}

export function ModalBackdrop({
  ariaLabel,
  onClose,
}: ModalBackdropProps): ReactElement {
  return (
    <div
      className="fixed inset-0 z-40 bg-black/50"
      onClick={onClose}
      onKeyDown={(event) => event.key === 'Escape' && onClose()}
      role="button"
      tabIndex={-1}
      aria-label={ariaLabel}
    />
  )
}
